<template>
    <div @keyup.enter="handleSubmit('formLogin')" class="layout" id="Login">
        <!--<div class="container" >-->
        <q-dialog persistent position="right" v-model="dialog">
            <AddApplication @closeCreatePartnerDialog="dialog=false"></AddApplication>
        </q-dialog>
        <!--&lt;!&ndash;<div @click="dialog=true" class="addButton-2 mr-0 d-flex" style="height: 40px;">&ndash;&gt;-->
        <!--&lt;!&ndash;<div class=" mx-auto my-auto">Add Application</div>&ndash;&gt;-->
        <!--&lt;!&ndash;</div>&ndash;&gt;-->
        <!--<div class="row">-->
        <!--<div class="col-8">-->
        <!--<div class="login-left-content q-pa-md pt-0">-->
        <!--<div class="login-header d-flex" style="align-items: center">-->
        <!--<div class="login-logo">-->
        <!--<img src="../../assets/logo-old.png" />-->
        <!--</div>-->
        <!--<h1>-->
        <!--AIPL PARTNER ENGAGEMENT PROGRAM-->
        <!--</h1>-->
        <!--</div>-->

        <!--<div class="login-scheme-img">-->

        <!--</div>-->
        <!--<div class="login-content mt-5">-->
        <!--<h6>Benefits of ESSET-Amity Partner Engagement Programme</h6>-->
        <!--<ul  class="ml-5">-->
        <!--<li><span>Earn Rewards everytime for your purchase</span></li>-->
        <!--<li><span>Boost additional Rewards thorugh your referral partners</span></li>-->
        <!--<li><span>Redeem Rewards as Cash</span></li>-->
        <!--<li><span>Start Selling more products</span></li>-->
        <!--</ul>-->
        <!--<p class="ml-5 mt-5">GET Partner Engagement Programme Details From <a href="#" target="_blank">here</a></p>-->
        <!--</div>-->

        <!--</div>-->
        <!--</div>-->
        <!--<div class="col-4">-->
        <!--<div class="login-right-content">-->
        <!--<div >-->
        <!--<img style="width: 50%" class="pt-5 d-block mx-auto" src="../../../src/assets/login_image.png" alt="">-->
        <!--</div>-->
        <!--<div class="loginBox p-3 pt-4">-->
        <!--<q-form ref="formLogin">-->
        <!--<div >-->
        <!--&lt;!&ndash;<h1>LOGIN</h1>&ndash;&gt;-->
        <!--<h3>PARTNER PORTAL</h3>-->
        <!--</div>-->
        <!--<q-input class="searchBox login-input my-3 p-2" style="border: 1px solid black; border-radius: 0px" :rules="[ val => val && val.length > 0]" dense-->
        <!--lazy-rules outlined label="Username"-->
        <!--v-model="formLogin.username">-->
        <!--<template slot="prepend">-->
        <!--&lt;!&ndash;<q-icon name="person"/>&ndash;&gt;-->
        <!--</template>-->
        <!--</q-input>-->

        <!--<q-input class="searchBox login-input my-3 p-2" style="border: 1px solid black; border-radius: 0px" :rules="[ val => val && val.length > 0]" dense-->
        <!--lazy-rules outlined label="Password"-->
        <!--type="password"-->
        <!--v-model="formLogin.password">-->
        <!--<template slot="prepend">-->
        <!--&lt;!&ndash;<q-icon name="lock"/>&ndash;&gt;-->
        <!--</template>-->
        <!--</q-input>-->

        <!--<q-btn @click="handleSubmit('formLogin')" class="pd-btn w-100" style="height: 50px; font-size: 24px; letter-spacing: 5px;">LOGIN</q-btn>-->
        <!--</q-form>-->
        <!--</div>-->

        <!--<div class="login-join-button">-->
        <!--<q-btn @click="dialog=true" class="pd-btn " style="height: 50px; width: 300px; font-size: 24px; letter-spacing: 3px; box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.13)">JOIN NOW</q-btn>-->
        <!--</div>-->


        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <div class="ppf-bg_img">
            <div class="card position-relative">
                <q-form ref="formLogin">
                    <div class="row">
                        <div class="col-12">
                            <div class="card-title">
                                <img src="../../assets/logo-old.png" width="40%"/>
                                <h6 style="letter-spacing: 2px">PARTNER LOGIN</h6>
                            </div>
                        </div>
                        <div class="col-12">
                            <q-input :rules="[ val => val && val.length > 0]" class="searchBox my-3 p-2" dense
                                     label="Username" lazy-rules outlined
                                     v-model="formLogin.username">
                                <template slot="prepend">
                                    <q-icon name="person"/>
                                </template>
                            </q-input>
                        </div>
                        <div class="col-12">
                            <q-input :rules="[ val => val && val.length > 0]" class="searchBox my-3 p-2" dense
                                     label="Password" lazy-rules outlined
                                     type="password"
                                     v-model="formLogin.password">
                                <template slot="prepend">
                                    <q-icon name="lock"/>
                                </template>
                            </q-input>
                        </div>
                        <div class="col-8">
                            <q-checkbox label="Remember Me" v-model="rememberMe"></q-checkbox>
                        </div>
                        <div class="col-12">
                            <q-btn @click="handleSubmit('formLogin')" class="mt-3"
                                   style="background: #0e88ce; color: #fff;">LOGIN
                            </q-btn>
                        </div>
                    </div>
                </q-form>

                <div class="login-links ">
                    <ul claas="d-flex mb-3" style="list-style: none;">
                        <li><a>TRUST &nbsp&nbsp| </a></li>
                        <li><a>TRANSPARENCY &nbsp&nbsp| </a></li>
                        <li><a>TEAM WORK</a></li>
                    </ul>

                    <div class="mt-5">
                        <q-btn @click="dialog=true" class="pd-btn"
                               style="background: #373286 !important; width: 280px;">BECOME AMITY PARTNER
                        </q-btn>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import Constants from '../../Constants/Constant'
  import { NetworkCommunicator } from '../../plugins/NetworkResourceHandler'
  import AddApplication from '../AddApplication'

  export default {
    name: 'Login',
    components: { AddApplication },
    data () {
      return {
        formLogin: {
          username: '',
          password: '',
        },
        rememberMe: false,
        company: null,
        dialog: false,
      }
    },
    methods: {
      handleSubmit (name) {
        this.$refs[name].validate().then(success => {
          if (success) {
            this.doLogin()
          } else {
            this.$q.notify('Invalid Credential')
          }
        })
      },
      async doLogin () {
        let self = this
        let response = await NetworkCommunicator('POST', `${Constants.api_url}partnerOwnerLogin`,
          false, { mobile: this.formLogin.username, password: this.formLogin.password, deviceType: 'Web' }, {})
        if (response.flag) {
          localStorage.setItem('token', response.data.token)
          localStorage.setItem('user', JSON.stringify(response.data))
          if (response.data.organization.isAggrementAccepted) {
            setTimeout(function () {
              self.$router.replace({ path: '/Partners/Dashboard' })
              self.$router.go()
            }, 500)
          } else {
            setTimeout(function () {
              self.$router.replace({ path: '/Partners/Agreement' })
              self.$router.go()
            }, 100)
          }
        } else {
          this.$q.notify(response.message)
        }
      },
    },
    beforeCreate () {
      if (localStorage.getItem('user') != undefined && localStorage.getItem('user') != '') {
        this.$router.replace({ path: '/' })
      }
    },
  }
</script>

<style>

    .ppf-bg_img {
        background-image: url("../../assets/login-bg.jpg");
        background-position: center;
        background-size: cover;
        display: flex;
        height: 100vh;
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
    }

    .ppf-bg_img .card {
        text-align: center;
        width: 350px;
        padding: 30px 40px;
        margin: auto;
        background-image: url("https://i.imgur.com/UbfG4Vh.png");
        background-color: #fff;
        background-repeat: no-repeat;
        background-position: bottom;
        border-radius: 4px;
        box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.3);
        position: relative;
        margin-top: 120px;
        left: -24%;
    }

    .ppf-bg_img .card-title {
        padding: 15px 0;
    }

    .ppf-bg_img .ppf-bg_img .img {
        padding: 15px 0px;
    }

    .ppf-bg_img .btn-login {
        background-color: #e30c3e;
        color: #fff;
        font-size: 18px;
        transition: 0.5s;
        otline: none;
    }

    .ppf-bg_img .btn-login:hover {
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
    }

    .ppf-bg_img .ppf-checkbox {
        text-align: left;
        margin-bottom: 0;
        padding-bottom: 30px;
    }
</style>
